import WeaponInfo from "./WeaponInfo";
export default WeaponInfo;
